import {
  MarketplaceProposal,
  MarketplaceProposalTemplateItem,
} from "../../../schema/generated/schema";
import { FormInstance } from "../ProposalForm/types";

export const formatCurrency = (price: number): string => {
  if (price > 0) {
    const formated = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    }).format(price);

    return formated;
  }
  return "-";
};

export const buyerName = (proposal: MarketplaceProposal): string => {
  if (proposal.buyer) {
    return `${proposal.buyer?.firstName} ${proposal.buyer?.lastName}`;
  }
  return proposal.unregisteredBuyerEmail || proposal.buyerUserId || "";
};

type FormTemplateItem = FormInstance | MarketplaceProposalTemplateItem;
export const compareItemsWithSortOrder = (
  item1: FormTemplateItem,
  item2: FormTemplateItem
) => {
  const sortOrder1 =
    item1.sortOrder === null ? Number.MAX_SAFE_INTEGER : item1.sortOrder;
  const sortOrder2 =
    item2.sortOrder === null ? Number.MAX_SAFE_INTEGER : item2.sortOrder;
  return sortOrder1 - sortOrder2;
};

export const sellerOnlyForms = ["Shipping", "Surcharge"];
